"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDot = exports.StyledCircle = exports.StyledPulsingDotContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
require("./PulsingDot.scss");
exports.StyledPulsingDotContainer = styled_components_1.default.div `
	position: relative;
	top: -1px;
`;
exports.StyledCircle = styled_components_1.default.div `
	border: 2px solid #62bd19;
	-webkit-border-radius: 2rem;
	border-radius: 2rem;
	height: 20px;
	width: 20px;
	-webkit-animation: pulsate 3s ease-out;
	animation: pulsate 3s ease-out;
	-webkit-animation-iteration-count: infinite;
	animation-iteration-count: infinite;
	opacity: 0;
	position: absolute;
	top: -10px;
	left: -10px;
`;
exports.StyledDot = styled_components_1.default.div `
	width: 10px;
	height: 10px;
	background-color: #62bd19;
	margin: auto;
	border-radius: 50%;
	position: absolute;
	top: -5px;
	left: -5px;
`;
